<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="12">
                <b-row class="mt-0 mb-0">
                    <b-col md="12">
                        <b-alert show>
                            <b>Overtime for {{ theseMonths }}.</b> <a href="#/overtime" style="font-size:14px!important; color:#0056b3!important; text-decoration:underline!important;">View all</a>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-show="true" :can-show-route-path="'#/overtime'" :can-delete="false" :can-approve="false" :can-reject="false" :can-edit="false" :data-url="apiUrl.overtime" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        props: {
            profileUuid: {
                type: String,
                required: false
            }
        },
        name: 'overtime-index',
        components: {
            PaginatedTable
        },
        data: function() {
        var currentDate = new Date();
        var monthlymonth = new Date(currentDate)
        var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDate= "01";
        var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

        var currentDate = new Date();
        var monthly = new Date(currentDate)
        var thismonth = ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDates= "31";
        var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + twoDigitFirstDates;

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ];
        var theseMonths = monthNames[currentDate.getMonth()]

            return {
                dataKey: 'overtime',
                apiUrl: {
                    overtime : window.AppConfig.apiUrl + 'overtime?requested_by=' + this.profileUuid + '&start_date=' + createdDateTo + '&end_date=' + thismonthday
                },
                theseMonths: theseMonths,
                createdDateTo: createdDateTo,
                thismonthday: thismonthday,
                columns: [
                    {
                        key: 'requestedByEmployee',
                        label: 'Employee',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: true
                    },
                    {
                        key: 'hour',
                        label: 'Total Hours',
                        sortable: true
                    },
                    {
                        key: 'overtimeType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'approvedBy',
                        label: 'Approved By'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'actionOvertimes',
                        label: ''
                    }
                ]
            }
        },
        methods: {
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            }
        }
    }
</script>